import { camelize } from 'humps'
import {
  SENSOR_READING_TYPES,
  PRESSURE_REPORT_READING_TYPES,
} from '../constants'

const MIC_COUNT_Y_AXIS_TITLE = 'Samples ≥ 85 dB per 10 min'

const getChartTypeKey = (pageSlug, reading) => `${pageSlug}::${reading}`

const getDefaultChartType = reading =>
  reading === SENSOR_READING_TYPES.MIC_COUNT ? 'column' : 'line'

const resolveChartType = (chartTypes, pageSlug, reading) =>
  chartTypes[getChartTypeKey(pageSlug, reading)] || getDefaultChartType(reading)

const getYAxisTitle = (reading, readingName, readingUnit) => {
  if (reading === SENSOR_READING_TYPES.MIC_COUNT) return MIC_COUNT_Y_AXIS_TITLE
  return readingUnit ? `${readingName} (${readingUnit.trim()})` : readingName
}

// the readings to chart on a pressure monitor page: those selected for the
// report (the API sends them snake_cased). Reports without a selection chart
// pressure, plus low / high when some reading carries them (v6.1+ packets)
const getPressureReportReadings = (items, selectedReadings) => {
  const readings = [
    PRESSURE_REPORT_READING_TYPES.PRESSURE,
    PRESSURE_REPORT_READING_TYPES.LOW_PRESSURE,
    PRESSURE_REPORT_READING_TYPES.HIGH_PRESSURE,
  ]

  if (selectedReadings) {
    const selected = selectedReadings.map(x => camelize(x))
    return readings.filter(reading => selected.includes(reading))
  }

  const hasReading = reading =>
    items.some(item => item.data.some(y => y[reading] != null))

  return readings.filter(
    reading =>
      reading === PRESSURE_REPORT_READING_TYPES.PRESSURE || hasReading(reading)
  )
}

export {
  getPressureReportReadings,
  getChartTypeKey,
  getDefaultChartType,
  resolveChartType,
  getYAxisTitle,
}
